import React from 'react';
import './accordion.scss';

export interface AccordionBodyProps {
    children: any;
    hasMargin?: boolean;
}

const AccordionBody = ({children, hasMargin}: AccordionBodyProps) => {
    return (
        <div className={`accordion__body ${hasMargin ? 'accordion__body--margin' : ''}`}>
            {children}
        </div>
    )
}

export default AccordionBody;
